import { forwardRef } from 'react';
import { Input, useColorModeValue } from '@chakra-ui/react';

/**
 * Custom Input component for Chakra UI integration with React-DatePicker
 * To be used as a customInput prop for DatePicker components across the application
 */
const DatePickerInput = forwardRef<
  HTMLInputElement, 
  { 
    value?: string; 
    onClick?: () => void; 
    placeholder?: string;
    size?: string;
  }
>(({ value, onClick, placeholder, size = "md" }, ref) => (
  <Input
    value={value}
    onClick={onClick}
    ref={ref}
    readOnly
    size={size}
    placeholder={placeholder || "Select date"}
    borderColor={useColorModeValue('gray.200', 'gray.600')}
    _focus={{
      borderColor: useColorModeValue('blue.500', 'blue.300'),
      boxShadow: `0 0 0 1px ${useColorModeValue('blue.500', 'blue.300')}`,
    }}
  />
));

DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;